import ClinicNameRender from '@medical/components/ClinicNameRender'
import {
  GUARANTEE_SHIFT_DOCTOR_LABEL,
  isGuaranteeShiftClinicName,
} from '@medical/constant'

// Doctor screens only. Staff screens keep using ClinicNameRender as is.
const DoctorClinicNameRender = ({ clinicalDepartment }) => {
  const clinicName = ClinicNameRender({ clinicalDepartment })
  return isGuaranteeShiftClinicName(clinicalDepartment.clinic.name)
    ? `${clinicName}　${GUARANTEE_SHIFT_DOCTOR_LABEL}`
    : clinicName
}

export default DoctorClinicNameRender
